import React from "react";
import LoaderButton from "../../../layout/components/LoaderButton";
import { cn } from "../../../../util/cn";
interface ConfirmButtonProps extends React.ComponentProps<typeof LoaderButton> {}

const CustomButton: React.FC<ConfirmButtonProps> = ({ className, ...props }) => {
  return <LoaderButton {...props} className={cn("w-[120px] h-10 rounded-lg", className)} />;
};

export default CustomButton;
